import { CreateEquipoDTO } from '@/application/dto/equipos/CreateEquipoDTO';
import { Equipo } from '@/domain/entities/equipo';
import { IEquipoRepository } from '@/domain/repositories/IEquipoRepository';

export class UpdateEquipoUseCase {
  constructor(
    private readonly repository: IEquipoRepository
  ) {}

  execute(id: string, data: CreateEquipoDTO): Promise<Equipo> {
    return this.repository.update(id, data);
  }
}
